// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class HeaderComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {
      headerLinks: [],
      mobileLinks: []
    }
  }
  
  mount() {  
    this.checkForActive()
  }
  
  checkForActive() {
    const currentPage = window.location.href;
    if(this.ref.headerLinks.length > 0) {
      this.ref.headerLinks.forEach(link => {
        if(currentPage.startsWith(link.href)) {
          link.classList.add('active-page');
        }
      })
    }

    if(this.ref.mobileLinks.length > 0) {
      this.ref.mobileLinks.forEach(link => {
        if(currentPage.startsWith(link.href)) {
          link.classList.add('active-page');
        }
      })
    }
  }
  
}